import script from "./DecimalNumberInput.vue?vue&type=script&setup=true&lang=ts"
export * from "./DecimalNumberInput.vue?vue&type=script&setup=true&lang=ts"

import "./DecimalNumberInput.vue?vue&type=style&index=0&id=6f402a5c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6f402a5c"]])

export default __exports__